import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { carrierHelperFailed, carrierHelperSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* carrierHelper(action) {
  try {
    let pool = {
      limit: 10,
      page: 1,
    };

    let filter = {};
    if (typeof action.payload === 'string') {
      filter.number = action.payload;
    }
    if (Array.isArray(action.payload)) {
      filter.numbers = action.payload;
    }
    if (typeof action.payload === 'object') {
      filter = action.payload;
    }
    pool = addFilterQueryWithCondition(filter, pool);

    yield delay(LOADING_DELAY);
    const url = `${BACKEND_URL}/registries/carriers`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(carrierHelperSuccessful(data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(carrierHelperFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(carrierHelperFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
